/*************************************
 *
 * 全局变量
 *
 *************************************/

/**
 * 页面高度
 *
 * @type {number}
 */
const pageHeight = document.documentElement.clientHeight

/**
 * 页面宽度
 *
 * @type {number}
 */
const pageWidth = document.documentElement.clientWidth

export default {
  pageHeight,
  pageWidth
}



// WEBPACK FOOTER //
// ./src/globalVariable.js